var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0c3.314 0 6 2.563 6 5.724S6 18 6 18 0 8.885 0 5.724C0 2.563 2.686 0 6 0zm0 2.842c-.796 0-1.559.3-2.121.832A2.769 2.769 0 0 0 3 5.684c0 .754.316 1.477.879 2.01A3.087 3.087 0 0 0 6 8.526c.796 0 1.559-.3 2.121-.832A2.769 2.769 0 0 0 9 5.684c0-.754-.316-1.476-.879-2.01A3.087 3.087 0 0 0 6 2.842z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointIcon);
export default __webpack_public_path__ + "static/media/mapPointIcon.ed97b71c84ea2fa84aa883c681bc3579.svg";
export { ForwardRef as ReactComponent };